import styles from "./css/ProjectHeader.module.css";
import { EntityInfoSection } from "@/components/pageParts/cityView/EntityInfoSection";
import { Button } from "@/components/Buttons/Button";
import { CityData, Project } from "@/types";
import { useNavigate, useParams } from "react-router-dom";
import TruncateText from "../addons/TruncatedText";
import { BackButton } from "@/components/Buttons/BackButton";
import { useTranslation } from "react-i18next";

interface ProjectHeaderProps {
    city: CityData | null;
    project: Project;
    isCompare: boolean;
}

export const ProjectHeader = ({city, project, isCompare}: ProjectHeaderProps) => {
    const navigate = useNavigate();
    const {entityName} = useParams<{entityName: string}>();
    const { t } = useTranslation('ProjectHeader');
    return (
                <div className={styles.container}>
                    {city && <EntityInfoSection entity={city} cardMode={true} project={project as Project} project_type={true}/>}
                    <div className={styles.col}> 
                        <div className={styles.contentWrapper}>
                            <div className={styles.blockRow}>
                                <div className={styles.blockPlotContainer}>
                                    <h1 className={styles.title}>{t('block')}</h1>
                                    <div className={styles.block}>{project?.block}</div>
                                </div>
                                <div className={styles.blockPlotContainer}>
                                    <h1 className={styles.title}>{t('plot')}</h1>
                                    <div className={styles.block}>{project?.plot}</div>
                                </div>
                            </div>
                            <div className={styles.descriptionContainer}>
                                <div className={styles.title}>{t('description')}</div>
                                <div className={styles.description}>
                                    <span className={styles.descriptionText}>{project?.description || ""}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.buttons}>
                    <Button id="editProject" 
                    icon="no" size="large" 
                    text={t('editProject')}
                     onClick={() => {navigate(`/${entityName}/project/${city?.id}/${project.id}/update`);}} 
                     color="blue" 
                     className={styles.font}/>

                    <BackButton className="w-full"/>
                    </div> 

                </div>
    );
}